import React, { Component } from 'react';

export class ViewSO extends Component {

    constructor(props) {
        super(props);
        this.getLineStatus = this.getLineStatus.bind(this);
    }

    getLineStatus(item) {
        var qty = parseInt(item.qty);
        var qtyPicked = parseInt(item.qtyPicked);
        var className;
        /*
         Nothing Done
         Partially Fulfilled
         Fully Fulfilled
         */
        console.log(item);
        if (item.isClosed) {
            className = "closed";
        }
        else if (item.doSubstitution) {
            className = "subbed";
        }
        else if (qty - qtyPicked == 0 || (item.isGiftCard && item.giftCardNum)) {
            className = "complete";
        }
        else if (item.isBackordered) {
            className = "backordered";
        }
        else if (qtyPicked == 0) {
            className = "noneFulfilled";
        }
        else {
            className = "partial";
        }
        return className;
    }

    render() {
        var getLineStatus = this.getLineStatus;
        return (
            <div>
                <h4>Tote - {this.props.orderInfo.tote}</h4>
                <h4 className='title'>{this.props.orderInfo.name} - {this.props.orderInfo.tranId}</h4>
                <h4 className='subtitle'>{this.props.orderInfo.date} - {this.props.orderInfo.status}</h4>
                <table>
                    <thead>
                        <tr>
                            <td>Shipping Method</td>
                            <td>Payment Method</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{this.props.orderInfo.shipMethod}</td>
                            <td>{this.props.orderInfo.payMethod}</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <thead>
                        <tr>
                            <td>Email</td>
                            <td>Phone</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{this.props.orderInfo.email}</td>
                            <td>{this.props.orderInfo.phone}</td>
                        </tr>
                    </tbody>
                </table>
                <table className='items'>
                    <thead>
                        <tr>
                            <td>Qty</td>
                            <td>Picked</td>
                            <td>Billed</td>
                            <td>Author</td>
                            <td>Serial #</td>
                            <td>Item</td>
                            <td>Unit Price</td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.orderInfo.items.map(function (item, idx) {
                            return (
                                <tr key={idx} className={getLineStatus(item)}>
                                    <td>{item.qty}</td>
                                    <td>{item.qtyPicked}</td>
                                    <td>{item.qtyBilled}</td>
                                    <td>{item.author}</td>
                                    <td>{item.serialNum}</td>
                                    <td>{item.item}</td>
                                    <td>{item.rate}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <button onClick={() => this.props.resetState()}>Back</button>
            </div>
        );
    }
}